module.exports = __webpack_public_path__ + "static/img/news_bg.23a12b2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/news_bg.png
// module id = k+VM
// module chunks = 12